import assetPath from '/app/brewery-packages/xds/background-images/assets/Background_01_7x2_a.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')